// Typelizer digest 77c03feae5c1d712c8dc5242d35242f6
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /api/question_answers/:id/toggle_published */
  togglePublished: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/api/question_answers/:id/toggle_published', params, options),
    method: 'post',
  }),

  /** GET /api/question_answers */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/api/question_answers', {}, options),
    method: 'get',
  }),

  /** POST /api/question_answers */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/api/question_answers', {}, options),
    method: 'post',
  }),
}
